import moment from 'moment';
//import * as md5 from 'md5'

export default class Post {
  id: string
  key
  userUid: string
  hash: string
  userName: string

  folder

  original
  
  name: string
  type: string
  tags: string
  
  provider: string
  api: string
  
  repost: string
  
  topic: string
  
  title: string
  picture: string
  
  source: string
  coverage
  content: string

  date: Date
  favorites: string[]

  //created_at: string

  created_at: Date
  hashtags
  video
  video_time
  video_player


  photo: string
  urls: string
  link: string
  l: number

  aware
  aware_at



  constructor(id, json) {
    this.id = id || 'erreur'
    this.key = id || 'erreur'
    //this.userUid = data.userUid || ''
    //this.userName = data.userName || ''
    this.original = json;

    let data = json.data;

    let aware = json.aware || [];
    if(aware) {
      //this.social.concat(aware);
      this.aware = this.sumAware(aware);
    }
    else this.aware = {};
    
    this.folder = data.folder || 'social'




    this.date = new Date(data.date)
    this.created_at = new Date(data.created_at)
    this.aware_at = data.aware_at;
    
    
    //this.type = data.type || ''
    //this.tag = data.tag || ''
    this.hashtags = data.hashtags || null
    
    this.provider = data.provider || ''
    
    this.picture = ''
    
    this.source = data.source || ''
    this.coverage = data.coverage || false
    this.content  = data.content || ''
    this.picture = data.picture || {}
    this.type = data.type || 'post'
    this.api = data.api || ''
    //console.log(this.coverage)
    this.repost = data.repost || null
    this.video = data.video || {}

    for(let i in this.video){
      this.video_player = this.video[i]
      
      if(this.video_player.time) {
        //let time = moment(this.video_player.time).format("HH:mm");
        this.video_time = this.convert(this.video_player.time)
      }
    }
    

    //moment(moment.duration(3500000)._data).format("HH:mm");
    
    
    //this.embed = data.video + '?autoplay=1';
    
    this.topic = data.topic || null
    this.photo = data.photo || null
    this.urls = data.urls || null
    this.link = data.link || null

    
    this.l = 4
    //this.hash = md5(this.userName)

    //this.aware = data.aware || {};

    
    
    //this.favorites = data.favorites || []
    //this.favoriteIcon
  }

  userAvatarUrl(size: number = 100): string {
    return `http://www.gravatar.com/avatar/${this.hash}?d=retro&s=${size}`
  }

  isFavoritedByUser(uid: string): boolean {
    return this.favorites.indexOf(uid) !== -1
  }

  sumAware (provider) {
    
    var sum = 0;

    for(let api in provider) {
      if(api === 'aware') sum += provider[api].aware //.count;
      if(api === 'facebook') sum += provider[api].like + provider[api].share //.count;
      if(api === 'twitter') sum += provider[api].like + provider[api].share //.count;
      if(api === 'youtube') sum += provider[api].like //.count;
    }
  
    return sum;
    
  }

  convert(seconde) {
    var secondes = Number(seconde);

    var hours = Math.floor(secondes / 3600);
    var minutes = Math.floor(secondes % 3600 / 60);
    var seconds = Math.floor(secondes % 3600 % 60);
    return ((hours > 0 ? hours + ":" + (minutes < 10 ? "0" : "") : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds); 
  }

  /*formattedDate(): string {
      
    
    moment.locale('fr');

          //const isToday = moment().isSame(this.created_at, 'day')
          //return moment(this.date).format(isToday ? 'hA' : 'MMM D')

    return moment(this.created_at).fromNow()
           
  }*/
}



// WEBPACK FOOTER //
// ./src/models/post.model.ts